<script>
export default {
	errorCaptured: (err, vm, info) => {
		// Custom error handling logic
		console.error(`Error captured in component: ${vm.$options.name}`);
		console.error(err);
		console.error(info);

		// Return false to prevent the error from propagating to parent components
		return false;
	}
};
</script>